import { lazy } from 'react';

/**
 * Admin surface for the server's scheduled tasks — list, run now, edit
 * schedule. Paired with the backend registry in
 * `kamil_store_backend_app/src/config/cron.js`.
 */
const CronJobsRoutes = [
  {
    path: 'settings/cron-jobs',
    component: lazy(() => import('views/cron-jobs')),
  },
];

export default CronJobsRoutes;
